import { render, staticRenderFns } from "./NQI.vue?vue&type=template&id=d70294de&scoped=true"
import script from "./NQI.vue?vue&type=script&lang=js"
export * from "./NQI.vue?vue&type=script&lang=js"
import style0 from "./NQI.vue?vue&type=style&index=0&id=d70294de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70294de",
  null
  
)

export default component.exports